import { AfterViewInit, Component, EventEmitter, OnInit, Output } from '@angular/core';
import * as faIcon from '@fortawesome/free-solid-svg-icons';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { iacOptionInterface } from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.component';
import { selfserviceQuestionInterface } from 'src/app/util/interfaces/selfserviceQuestion';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { SelfservicePageService } from './service/selfservice-page.service';
import { PermissionService } from 'src/app/util/services/permission/permission.service';
import { ActivatedRoute } from '@angular/router';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { Subscription } from 'rxjs';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';
import { CommonModule } from '@angular/common';
import { SvgGearsModule } from 'src/app/page_component_item/svg-gears/svg-gears.module';
import { RequestOpeningComponent } from 'src/app/page_component/request-opening/request-opening.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DotBounceLoadingEffectModule } from 'src/app/page_component_item/dot-bounce-loading-effect/dot-bounce-loading-effect.module';
import { InputWithAutocompleteModule } from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.module';

@Component({
	standalone: true,
	imports: [
		CommonModule,
		SvgGearsModule,
		RequestOpeningComponent,
		FontAwesomeModule,
		DotBounceLoadingEffectModule,
		InputWithAutocompleteModule,
	],
	selector: 'pcp-selfservice-page',
	templateUrl: './selfservice-page.component.html',
	styleUrls: ['./selfservice-page.component.scss'],
})
export class SelfservicePageComponent implements OnInit {
	@Output()
	leavePage = new EventEmitter();

	@Output()
	newRequestCreated = new EventEmitter();

	faIcon = faIcon;

	labels: LabelsInterface = {
		lbl_geral_inicio: 'Start',
		lbl_geral_detalhamento: 'Description',
		lbl_asset_other: 'Others',
		lbl_chamado_solicitacao: 'Summary',
		lbl_geral_descricao: 'Description',
		lbl_para_quem: 'For who is the request',
		lbl_para_mim: 'For me',
		lbl_para_outra_pessoa: 'For other person',
		lbl_search_person: 'Search the person below and filter here',
		lbl_geral_campos_customizados: 'Custom fields',
		lbl_geral_selecione: 'Select',
		lbl_chamado_abrir: 'Open request',
		lbl_edocs_carregando: 'Loading',
		lbl_request_successful_open: 'Request successful open',
		lbl_clique_aqui_para_chamado: 'Click here to go to the request',
		lbl_lets_start_what_is_your_request: 'Lets begin, tell me, what is your request?',
		lbl_nenhum_usuario_encontrado_com_essa_entrada: 'No users found with this input',
		lbl_action_open_kb: 'This action will open a KB, click here to continue',
		lbl_action_open_exturl: 'This action will open an external page, click here to continue',
		lbl_catalogo_incompleto: 'This catalog is incomplete, if you think this should not happen, please contact your mySupport team',
		lbl_sumario_nao_pode_ser_vazio: 'The request summary cannot be empty!',
		lbl_selecione_usuario_do_chamado: 'Do not forget to select who you will open the ticket for!',
		lbl_preencha_todos_campos_customizados: 'Please fill in all custom fields marked by *',
		lbl_geral_autoatendimento: 'Selfservice',
		lbl_geral_criado: 'Criado',
		lbl_chamado_tipo_servico: 'Service type',
		lbl_geral_competencia: 'Competence',
		lbl_asset_category: 'Category',
		lbl_geral_topico: 'Topic',
		lbl_geral_grupo: 'Group',
		lbl_rep_tipo_change: 'Change type',
		lbl_geral_classificacao: 'Classification',
		lbl_calendar_now: 'Now',
		lbl_geral_cancelar: 'Cancel',
		lbl_classificar_agora: 'Classify request now',
		lbl_classificar_depois: 'Classify request after',
		lbl_preencha_todos_campos_classificar: 'Fill all custom fields to classify the request!',
		lbl_possiveis_arquivos_podem_ajudar: '',
		lbl_geral_continuar: 'Continue',
		lbl_sem_permissao_solicitacao: 'You do not have permission to make this type of request',
		lbl_geral_buscar: '',
		lbl_geral_cliente: '',
	};

	constructor(
		private SelfservicePageService: SelfservicePageService,
		private NotificationService: NotificationService,
		private LabelsService: LabelsService,
		private ActivatedRoute: ActivatedRoute,
		public PermissionService: PermissionService,
		public ProfileService: ProfileService
	) {}

	isLoadingLabels = true;
	isLoadingAvailableCustomers = true;
	isLoadingAvailableUsers = true;
	isLoadingCustomerPermission = false;
	isLoadingSelfservice = false;
	isLoadingNextQuestion = false;

	isEnduser = localStorage.getItem('sessionStatus') == '0';
	requestTemplateId = '';
	requestOpeningOptions = {
		id_customer: '',
		id_enduser: '',
		enduser: '',
		REQUEST_OPENING_no_other: false,
	};

	availableCustomerIAC: iacOptionInterface[] = [];
	availableUsersIAC: iacOptionInterface[] = [];
	availableUsersReq: Subscription;

	//Memory são as perguntas que já passaram e foram selecionadas, o array corresponde a pergunta atual!
	selfserviceQuestionMemory: selfserviceQuestionInterface[] = [];
	selfserviceQuestionArray: selfserviceQuestionInterface[] = [];

	selfserviceView = {
		actualStep: 0,
		lastAvailableStep: 0,
		selfservicePrePhase: 0,
		selfserviceQuestions: 1,
		selfserviceDetailment: 2,
		selfserviceEnd: 3,
	};

	resetDetailmentBool = false;

	ngOnInit(): void {
		this.ActivatedRoute.queryParams.subscribe((parameters) => {
			if (parameters.idCmdb && parameters.idCmdb != '') {
				this.setNoTemplateRequest();
			}
		});

		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});

		// Carrega os customers disponíveis tanto para analista quanto para enduser
		this.ProfileService.getAvailableCustomers()
			.subscribe({
				next: (customerRes) => {
					for (const customer of customerRes) {
						const customerIAC: iacOptionInterface = {
							name: customer.customer,
							value: customer.id,
						};
						this.availableCustomerIAC.push(customerIAC);
					}

					// Se for enduser, pré-seleciona o customer e usuário atual
					if (this.isEnduser) {
						this.setCustomer(this.ProfileService.userData().idCustomer);
						this.requestOpeningOptions.id_enduser = this.ProfileService.userData().id;
						this.requestOpeningOptions.enduser = this.ProfileService.userData().fullName;
					} else {
						this.setCustomer(this.ProfileService.userData().idCustomer);
					}
				},
			})
			.add(() => {
				this.isLoadingAvailableCustomers = false;
			});
	}

	setCustomer(id_customer: string): void {
		if (!id_customer || id_customer == '') return;

		this.requestOpeningOptions.id_customer = id_customer;
		this.getAvailableUsers(id_customer);

		this.isLoadingCustomerPermission = true;
		this.PermissionService.getCustomersPermissionsList(id_customer)
			.subscribe({
				next: (permissionList) => {
					this.requestOpeningOptions.REQUEST_OPENING_no_other = !permissionList.includes('REQUEST_OPENING_no_other');
				},
			})
			.add(() => {
				this.isLoadingCustomerPermission = false;
			});
	}

	getAvailableUsers(id_customer: string): void {
		if (!id_customer || id_customer == '') return;

		this.isLoadingAvailableUsers = true;
		this.availableUsersIAC = [];
		if (this.availableUsersReq) this.availableUsersReq.unsubscribe();
		this.availableUsersReq = this.SelfservicePageService.getAvailableUsers(id_customer).subscribe({
			next: (availableUsers) => {
				for (const user of availableUsers) {
					const userIAC: iacOptionInterface = {
						name: user.fullName,
						value: user.id,
						secondName: user.email,
					};
					this.availableUsersIAC.push(userIAC);
				}
			},
		});

		this.availableUsersReq.add(() => {
			if (this.availableUsersIAC.length > 0) {
				setTimeout(() => {
					this.requestOpeningOptions.id_enduser = this.ProfileService.userData().id;
					this.requestOpeningOptions.enduser = this.ProfileService.userData().fullName;
					this.isLoadingAvailableUsers = false;
				}, 10);
			}
		});
	}

	getFirstQuestion(id_customer: string): void {
		this.isLoadingNextQuestion = true;
		this.SelfservicePageService.getSelfserviceFirstQuestion(id_customer).subscribe({
			next: (selfserviceQuestionRes) => {
				this.selfserviceQuestionArray = selfserviceQuestionRes;
				if (this.selfserviceQuestionArray.length === 0) this.setNoTemplateRequest();
				this.isLoadingNextQuestion = false;
			},
			error: () => {
				this.selfserviceQuestionArray = [];
				this.setNoTemplateRequest();
				this.isLoadingNextQuestion = false;
			},
		});
	}

	getNextQuestion(selfserviceQuestion: selfserviceQuestionInterface): void {
		if (selfserviceQuestion.exturl == '' && selfserviceQuestion.idCategory && selfserviceQuestion.idCategory !== 'null') {
			this.resetDetailment();
			const storeSelfserviceQuestion: selfserviceQuestionInterface = selfserviceQuestion;
			this.isLoadingNextQuestion = true;
			this.SelfservicePageService.getNextQuestionByCategory(
				selfserviceQuestion.idCategory,
				this.requestOpeningOptions.id_customer
			).subscribe({
				next: (selfserviceQuestionRes) => {
					this.selfserviceQuestionMemory.push(storeSelfserviceQuestion);
					this.selfserviceQuestionArray = selfserviceQuestionRes;
				},
				error: () => {
					this.NotificationService.setNotificationMessage(this.labels.lbl_catalogo_incompleto);
					this.getPreviousQuestion();
				},
				complete: () => {
					this.isLoadingNextQuestion = false;
				},
			});
		} else if (selfserviceQuestion.idNextQuestion && selfserviceQuestion.idNextQuestion !== 'null') {
			this.resetDetailment();
			const storeSelfserviceQuestion: selfserviceQuestionInterface = selfserviceQuestion;
			this.isLoadingNextQuestion = true;
			this.SelfservicePageService.getNextQuestion(selfserviceQuestion.idNextQuestion).subscribe(
				(selfserviceQuestionRes) => {
					this.selfserviceQuestionMemory.push(storeSelfserviceQuestion);
					this.selfserviceQuestionArray = selfserviceQuestionRes;
					this.isLoadingNextQuestion = false;
				},
				() => {
					this.NotificationService.setNotificationMessage(this.labels.lbl_catalogo_incompleto);
					this.getPreviousQuestion();
					this.isLoadingNextQuestion = false;
				}
			);
		} else if (selfserviceQuestion.idResponseTemplate && selfserviceQuestion.idResponseTemplate !== 'null') {
			if (this.requestTemplateId !== '') {
				this.selfserviceQuestionMemory.pop();
			}
			this.requestTemplateId = selfserviceQuestion.idResponseTemplate;
			this.selfserviceView.lastAvailableStep = this.selfserviceView.selfserviceDetailment;
			this.selfserviceView.actualStep = this.selfserviceView.selfserviceDetailment;
		} else if (selfserviceQuestion.idResponseKb && selfserviceQuestion.idResponseKb !== 'null') {
			this.NotificationService.setNotificationMessage(this.labels.lbl_action_open_kb);
			this.NotificationService.setFunctionOnMessage(() => {
				window.open('knowledgebase/read/' + selfserviceQuestion.idResponseKb, '_blank');
			});
		} else if (selfserviceQuestion.exturl && selfserviceQuestion.exturl !== 'null') {
			this.NotificationService.setNotificationMessage(this.labels.lbl_action_open_exturl);
			if (!/^http?:\/\//i.test(selfserviceQuestion.exturl) || !/^https?:\/\//i.test(selfserviceQuestion.exturl)) {
				this.NotificationService.setFunctionOnMessage(() => {
					window.open('https://' + selfserviceQuestion.exturl, '_blank');
				});
			} else {
				this.NotificationService.setFunctionOnMessage(() => {
					window.open(selfserviceQuestion.exturl, '_blank');
				});
			}
		} else if (
			(this.selfserviceQuestionMemory.length === 0 || this.selfserviceQuestionMemory.length === 1) &&
			selfserviceQuestion.idQuestion &&
			selfserviceQuestion.idQuestion !== 'null'
		) {
			this.resetDetailment();
			const storeSelfserviceQuestion: selfserviceQuestionInterface = selfserviceQuestion;
			this.isLoadingNextQuestion = true;
			this.SelfservicePageService.getNextQuestion(selfserviceQuestion.idQuestion).subscribe(
				(selfserviceQuestionRes) => {
					this.selfserviceQuestionMemory.push(storeSelfserviceQuestion);
					this.selfserviceQuestionArray = selfserviceQuestionRes;
					this.isLoadingNextQuestion = false;
				},
				() => {
					this.NotificationService.setNotificationMessage(this.labels.lbl_catalogo_incompleto);
					this.getPreviousQuestion();
					this.isLoadingNextQuestion = false;
				}
			);
		} else {
			this.NotificationService.setNotificationMessage(this.labels.lbl_catalogo_incompleto);
		}
	}

	getPreviousQuestion(): void {
		this.resetDetailment();
		this.selfserviceQuestionMemory.pop();
		if (this.selfserviceQuestionMemory.length === 0) {
			this.getFirstQuestion(this.requestOpeningOptions.id_customer);
		} else {
			this.getNextQuestion(this.selfserviceQuestionMemory.at(-1));
			this.selfserviceQuestionMemory.pop();
		}
	}

	setNoTemplateRequest(): void {
		this.resetDetailment();
		this.selfserviceView.actualStep = this.selfserviceView.selfserviceDetailment;
		this.selfserviceView.lastAvailableStep = this.selfserviceView.selfserviceDetailment;
	}

	resetSelfservice(): void {
		this.selfserviceQuestionMemory = [];
		this.selfserviceQuestionArray = [];
		this.requestTemplateId = '';
		this.selfserviceView.actualStep = 0;
		this.selfserviceView.lastAvailableStep = 0;
		this.getFirstQuestion(this.requestOpeningOptions.id_customer);
	}

	resetDetailment(): void {
		this.resetDetailmentBool = true;
		setTimeout(() => {
			this.resetDetailmentBool = false;
		}, 1);
	}

	redirectTo(to: string): void {
		window.open(to, '_blank');
	}

	//Comunication with father component
	emitLeavePage(): void {
		this.leavePage.emit('true');
	}

	emitRequestCreated(): void {
		this.newRequestCreated.emit('true');
	}

	requestOpened(): void {
		this.selfserviceView.lastAvailableStep = this.selfserviceView.selfserviceEnd;
		this.selfserviceView.actualStep = this.selfserviceView.selfserviceEnd;
		this.emitRequestCreated();
	}

	handleClick(selfserviceCard: any): void {
		if (selfserviceCard.classificationRestricted == 1) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_sem_permissao_solicitacao);
		} else {
			this.getNextQuestion(selfserviceCard);
		}
	}
}
